"use client";

import { cn } from "@/lib/utils";
import type { Ref } from "react";
import { Button } from "./button";

type SelectorTriggerProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  rightAdornment?: React.ReactNode;
  leftAdornment?: React.ReactNode;
  ref?: Ref<HTMLButtonElement>;
};

export function SelectorTrigger({
  className,
  children,
  rightAdornment,
  leftAdornment,
  ref,
  ...props
}: SelectorTriggerProps) {
  return (
    <Button
      variant="outline"
      ref={ref}
      className={cn(
        "h-10 px-4 text-left text-base transition-colors cursor-pointer shadow-none border-0 bg-transparent font-medium leading-6 rounded-full",
        className,
      )}
      {...props}
    >
      {leftAdornment ? (
        <span className="mr-2 shrink-0 flex items-center">{leftAdornment}</span>
      ) : null}
      <span className="flex-1 text-foreground truncate">{children}</span>
      {rightAdornment ? (
        <span className="ml-2 shrink-0 flex items-center">
          {rightAdornment}
        </span>
      ) : null}
    </Button>
  );
}
